import { render, staticRenderFns } from "./Terminat-Warranty.vue?vue&type=template&id=022b0b0b&scoped=true"
import script from "./Terminat-Warranty.vue?vue&type=script&lang=js"
export * from "./Terminat-Warranty.vue?vue&type=script&lang=js"
import style0 from "./Terminat-Warranty.vue?vue&type=style&index=0&id=022b0b0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022b0b0b",
  null
  
)

export default component.exports